<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import { isTestCafeAuthEnabled, isTestCafeEnabled } from '@/helpers/isTestCafeEnabled'
import { RouterView } from 'vue-router'
import { storeToRefs } from 'pinia'

import ForcedLogoutModal from '@/components/widgets/modal/ForcedLogoutModal.vue'
import InactivityModal from '@/components/widgets/modal/InactivityModal.vue'
import ApToaster from '@/components/widgets/toast/ApToaster.vue'

import { useModalsStore } from '@/stores/modals'

useAuth()

const modalsStore = useModalsStore()
const { currentComponent } = storeToRefs(modalsStore)
</script>

<template>
  <div id="app" :class="{ testcafe: isTestCafeEnabled() || isTestCafeAuthEnabled() }">
    <InactivityModal></InactivityModal>
    <ForcedLogoutModal></ForcedLogoutModal>
    <ApToaster />

    <!-- Global modal container for Pinia-based modals -->
    <Teleport to="body">
      <Suspense>
        <component :is="currentComponent" v-if="currentComponent" />
      </Suspense>
    </Teleport>

    <suspense>
      <RouterView />
    </suspense>
  </div>
</template>
